import { cx } from '@/lib/cva'

export function Stack({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cx('flex flex-col gap-4', className)}>{children}</div>
}
